[
  { "year": 2000, "region": "AK", "growthRate": 0.055, "taxRate": 0.0104 },
  { "year": 2000, "region": "AL", "growthRate": 0.05, "taxRate": 0.0033 },
  { "year": 2000, "region": "AR", "growthRate": 0.05, "taxRate": 0.0054 },
  { "year": 2000, "region": "AZ", "growthRate": 0.115, "taxRate": 0.0081 },
  { "year": 2000, "region": "CA", "growthRate": 0.159, "taxRate": 0.0078 },
  { "year": 2000, "region": "CO", "growthRate": 0.122, "taxRate": 0.0068 },
  { "year": 2000, "region": "CT", "growthRate": 0.116, "taxRate": 0.0143 },
  { "year": 2000, "region": "DC", "growthRate": 0.112, "taxRate": 0.0094 },
  { "year": 2000, "region": "DE", "growthRate": 0.072, "taxRate": 0.0043 },
  { "year": 2000, "region": "FL", "growthRate": 0.066, "taxRate": 0.0101 },
  { "year": 2000, "region": "GA", "growthRate": 0.065, "taxRate": 0.0082 },
  { "year": 2000, "region": "HI", "growthRate": 0.103, "taxRate": 0.0026 },
  { "year": 2000, "region": "ID", "growthRate": 0.092, "taxRate": 0.0076 },
  { "year": 2000, "region": "IL", "growthRate": 0.061, "taxRate": 0.0198 },
  { "year": 2000, "region": "IN", "growthRate": 0.062, "taxRate": 0.0069 },
  { "year": 2000, "region": "KS", "growthRate": 0.031, "taxRate": 0.0119 },
  { "year": 2000, "region": "KY", "growthRate": 0.039, "taxRate": 0.0074 },
  { "year": 2000, "region": "MA", "growthRate": 0.159, "taxRate": 0.0105 },
  { "year": 2000, "region": "MI", "growthRate": 0.061, "taxRate": 0.0155 },
  { "year": 2000, "region": "NE", "growthRate": 0.045, "taxRate": 0.0176 },
  { "year": 2000, "region": "NV", "growthRate": 0.137, "taxRate": 0.0086 },
  { "year": 2000, "region": "OH", "growthRate": 0.049, "taxRate": 0.013 },
  { "year": 2000, "region": "SC", "growthRate": 0.06, "taxRate": 0.0049 },
  { "year": 2000, "region": "WA", "growthRate": 0.104, "taxRate": 0.0099 },
  { "year": 2001, "region": "AK", "growthRate": 0.054, "taxRate": 0.0104 },
  { "year": 2001, "region": "AL", "growthRate": 0.048, "taxRate": 0.0033 },
  { "year": 2001, "region": "AR", "growthRate": 0.048, "taxRate": 0.0053 },
  { "year": 2001, "region": "AZ", "growthRate": 0.118, "taxRate": 0.0081 },
  { "year": 2001, "region": "CA", "growthRate": 0.132, "taxRate": 0.0079 },
  { "year": 2001, "region": "CO", "growthRate": 0.08, "taxRate": 0.0068 },
  { "year": 2001, "region": "CT", "growthRate": 0.097, "taxRate": 0.0143 },
  { "year": 2001, "region": "DC", "growthRate": 0.129, "taxRate": 0.0094 },
  { "year": 2001, "region": "DE", "growthRate": 0.076, "taxRate": 0.0043 },
  { "year": 2001, "region": "FL", "growthRate": 0.087, "taxRate": 0.0101 },
  { "year": 2001, "region": "GA", "growthRate": 0.068, "taxRate": 0.0082 },
  { "year": 2001, "region": "HI", "growthRate": 0.094, "taxRate": 0.0026 },
  { "year": 2001, "region": "ID", "growthRate": 0.064, "taxRate": 0.0076 },
  { "year": 2001, "region": "IL", "growthRate": 0.066, "taxRate": 0.0198 },
  { "year": 2001, "region": "IN", "growthRate": 0.061, "taxRate": 0.0069 },
  { "year": 2001, "region": "KS", "growthRate": 0.037, "taxRate": 0.0119 },
  { "year": 2001, "region": "KY", "growthRate": 0.046, "taxRate": 0.0074 },
  { "year": 2001, "region": "MA", "growthRate": 0.116, "taxRate": 0.0105 },
  { "year": 2001, "region": "MI", "growthRate": 0.059, "taxRate": 0.0155 },
  { "year": 2001, "region": "NE", "growthRate": 0.044, "taxRate": 0.0176 },
  { "year": 2001, "region": "NV", "growthRate": 0.079, "taxRate": 0.0086 },
  { "year": 2001, "region": "OH", "growthRate": 0.052, "taxRate": 0.013 },
  { "year": 2001, "region": "SC", "growthRate": 0.056, "taxRate": 0.0049 },
  { "year": 2001, "region": "WA", "growthRate": 0.069, "taxRate": 0.0099 },
  { "year": 2002, "region": "AK", "growthRate": 0.06, "taxRate": 0.0104 },
  { "year": 2002, "region": "AL", "growthRate": 0.049, "taxRate": 0.0033 },
  { "year": 2002, "region": "AR", "growthRate": 0.049, "taxRate": 0.0053 },
  { "year": 2002, "region": "AZ", "growthRate": 0.13, "taxRate": 0.0081 },
  { "year": 2002, "region": "CA", "growthRate": 0.165, "taxRate": 0.0078 },
  { "year": 2002, "region": "CO", "growthRate": 0.049, "taxRate": 0.0068 },
  { "year": 2002, "region": "CT", "growthRate": 0.1, "taxRate": 0.0143 },
  { "year": 2002, "region": "DC", "growthRate": 0.157, "taxRate": 0.0094 },
  { "year": 2002, "region": "DE", "growthRate": 0.084, "taxRate": 0.0043 },
  { "year": 2002, "region": "FL", "growthRate": 0.107, "taxRate": 0.0101 },
  { "year": 2002, "region": "GA", "growthRate": 0.062, "taxRate": 0.0082 },
  { "year": 2002, "region": "HI", "growthRate": 0.13, "taxRate": 0.0026 },
  { "year": 2002, "region": "ID", "growthRate": 0.06, "taxRate": 0.0076 },
  { "year": 2002, "region": "IL", "growthRate": 0.065, "taxRate": 0.0198 },
  { "year": 2002, "region": "IN", "growthRate": 0.053, "taxRate": 0.0069 },
  { "year": 2002, "region": "KS", "growthRate": 0.038, "taxRate": 0.0119 },
  { "year": 2002, "region": "KY", "growthRate": 0.046, "taxRate": 0.0074 },
  { "year": 2002, "region": "MA", "growthRate": 0.104, "taxRate": 0.0105 },
  { "year": 2002, "region": "MI", "growthRate": 0.062, "taxRate": 0.0155 },
  { "year": 2002, "region": "NE", "growthRate": 0.041, "taxRate": 0.0176 },
  { "year": 2002, "region": "NV", "growthRate": 0.112, "taxRate": 0.0086 },
  { "year": 2002, "region": "OH", "growthRate": 0.052, "taxRate": 0.013 },
  { "year": 2002, "region": "SC", "growthRate": 0.048, "taxRate": 0.0049 },
  { "year": 2002, "region": "WA", "growthRate": 0.074, "taxRate": 0.0099 },
  { "year": 2003, "region": "AK", "growthRate": 0.077, "taxRate": 0.0104 },
  { "year": 2003, "region": "AL", "growthRate": 0.055, "taxRate": 0.0033 },
  { "year": 2003, "region": "AR", "growthRate": 0.055, "taxRate": 0.0053 },
  { "year": 2003, "region": "AZ", "growthRate": 0.185, "taxRate": 0.0081 },
  { "year": 2003, "region": "CA", "growthRate": 0.216, "taxRate": 0.0076 },
  { "year": 2003, "region": "CO", "growthRate": 0.045, "taxRate": 0.0068 },
  { "year": 2003, "region": "CT", "growthRate": 0.097, "taxRate": 0.0143 },
  { "year": 2003, "region": "DC", "growthRate": 0.177, "taxRate": 0.0094 },
  { "year": 2003, "region": "DE", "growthRate": 0.092, "taxRate": 0.0043 },
  { "year": 2003, "region": "FL", "growthRate": 0.135, "taxRate": 0.0101 },
  { "year": 2003, "region": "GA", "growthRate": 0.066, "taxRate": 0.0082 },
  { "year": 2003, "region": "HI", "growthRate": 0.178, "taxRate": 0.0026 },
  { "year": 2003, "region": "ID", "growthRate": 0.065, "taxRate": 0.0076 },
  { "year": 2003, "region": "IL", "growthRate": 0.067, "taxRate": 0.0198 },
  { "year": 2003, "region": "IN", "growthRate": 0.048, "taxRate": 0.0069 },
  { "year": 2003, "region": "KS", "growthRate": 0.042, "taxRate": 0.0119 },
  { "year": 2003, "region": "KY", "growthRate": 0.047, "taxRate": 0.0074 },
  { "year": 2003, "region": "MA", "growthRate": 0.095, "taxRate": 0.0105 },
  { "year": 2003, "region": "MI", "growthRate": 0.061, "taxRate": 0.0155 },
  { "year": 2003, "region": "NE", "growthRate": 0.042, "taxRate": 0.0176 },
  { "year": 2003, "region": "NV", "growthRate": 0.213, "taxRate": 0.0086 },
  { "year": 2003, "region": "OH", "growthRate": 0.051, "taxRate": 0.013 },
  { "year": 2003, "region": "SC", "growthRate": 0.047, "taxRate": 0.0049 },
  { "year": 2003, "region": "WA", "growthRate": 0.078, "taxRate": 0.0099 },
  { "year": 2004, "region": "AK", "growthRate": 0.096, "taxRate": 0.0104 },
  { "year": 2004, "region": "AL", "growthRate": 0.072, "taxRate": 0.0033 },
  { "year": 2004, "region": "AR", "growthRate": 0.072, "taxRate": 0.0053 },
  { "year": 2004, "region": "AZ", "growthRate": 0.311, "taxRate": 0.0081 },
  { "year": 2004, "region": "CA", "growthRate": 0.254, "taxRate": 0.0074 },
  { "year": 2004, "region": "CO", "growthRate": 0.055, "taxRate": 0.0068 },
  { "year": 2004, "region": "CT", "growthRate": 0.115, "taxRate": 0.0143 },
  { "year": 2004, "region": "DC", "growthRate": 0.213, "taxRate": 0.0094 },
  { "year": 2004, "region": "DE", "growthRate": 0.12, "taxRate": 0.0043 },
  { "year": 2004, "region": "FL", "growthRate": 0.245, "taxRate": 0.0101 },
  { "year": 2004, "region": "GA", "growthRate": 0.092, "taxRate": 0.0082 },
  { "year": 2004, "region": "HI", "growthRate": 0.267, "taxRate": 0.0026 },
  { "year": 2004, "region": "ID", "growthRate": 0.116, "taxRate": 0.0076 },
  { "year": 2004, "region": "IL", "growthRate": 0.08, "taxRate": 0.0198 },
  { "year": 2004, "region": "IN", "growthRate": 0.054, "taxRate": 0.0069 },
  { "year": 2004, "region": "KS", "growthRate": 0.05, "taxRate": 0.0119 },
  { "year": 2004, "region": "KY", "growthRate": 0.054, "taxRate": 0.0074 },
  { "year": 2004, "region": "MA", "growthRate": 0.113, "taxRate": 0.0105 },
  { "year": 2004, "region": "MI", "growthRate": 0.066, "taxRate": 0.0155 },
  { "year": 2004, "region": "NE", "growthRate": 0.049, "taxRate": 0.0176 },
  { "year": 2004, "region": "NV", "growthRate": 0.398, "taxRate": 0.0086 },
  { "year": 2004, "region": "OH", "growthRate": 0.058, "taxRate": 0.013 },
  { "year": 2004, "region": "SC", "growthRate": 0.065, "taxRate": 0.0049 },
  { "year": 2004, "region": "WA", "growthRate": 0.126, "taxRate": 0.0099 },
  { "year": 2005, "region": "AK", "growthRate": 0.107, "taxRate": 0.0104 },
  { "year": 2005, "region": "AL", "growthRate": 0.09, "taxRate": 0.0033 },
  { "year": 2005, "region": "AR", "growthRate": 0.09, "taxRate": 0.0052 },
  { "year": 2005, "region": "AZ", "growthRate": 0.402, "taxRate": 0.0062 },
  { "year": 2005, "region": "CA", "growthRate": 0.177, "taxRate": 0.0075 },
  { "year": 2005, "region": "CO", "growthRate": 0.094, "taxRate": 0.0061 },
  { "year": 2005, "region": "CT", "growthRate": 0.088, "taxRate": 0.0152 },
  { "year": 2005, "region": "DC", "growthRate": 0.246, "taxRate": 0.0056 },
  { "year": 2005, "region": "DE", "growthRate": 0.139, "taxRate": 0.0043 },
  { "year": 2005, "region": "FL", "growthRate": 0.272, "taxRate": 0.0106 },
  { "year": 2005, "region": "GA", "growthRate": 0.114, "taxRate": 0.0083 },
  { "year": 2005, "region": "HI", "growthRate": 0.246, "taxRate": 0.0026 },
  { "year": 2005, "region": "ID", "growthRate": 0.203, "taxRate": 0.0076 },
  { "year": 2005, "region": "IL", "growthRate": 0.081, "taxRate": 0.0171 },
  { "year": 2005, "region": "IN", "growthRate": 0.051, "taxRate": 0.0069 },
  { "year": 2005, "region": "KS", "growthRate": 0.052, "taxRate": 0.0125 },
  { "year": 2005, "region": "KY", "growthRate": 0.051, "taxRate": 0.0074 },
  { "year": 2005, "region": "MA", "growthRate": 0.033, "taxRate": 0.0105 },
  { "year": 2005, "region": "MI", "growthRate": 0.048, "taxRate": 0.0155 },
  { "year": 2005, "region": "NE", "growthRate": 0.049, "taxRate": 0.0176 },
  { "year": 2005, "region": "NV", "growthRate": 0.175, "taxRate": 0.0086 },
  { "year": 2005, "region": "OH", "growthRate": 0.05, "taxRate": 0.013 },
  { "year": 2005, "region": "SC", "growthRate": 0.084, "taxRate": 0.0049 },
  { "year": 2005, "region": "WA", "growthRate": 0.176, "taxRate": 0.0099 },
  { "year": 2006, "region": "AK", "growthRate": 0.079, "taxRate": 0.0105 },
  { "year": 2006, "region": "AL", "growthRate": 0.056, "taxRate": 0.0033 },
  { "year": 2006, "region": "AR", "growthRate": 0.056, "taxRate": 0.0052 },
  { "year": 2006, "region": "AZ", "growthRate": 0.112, "taxRate": 0.0062 },
  { "year": 2006, "region": "CA", "growthRate": 0.028, "taxRate": 0.0076 },
  { "year": 2006, "region": "CO", "growthRate": 0.056, "taxRate": 0.0061 },
  { "year": 2006, "region": "CT", "growthRate": 0.013, "taxRate": 0.0152 },
  { "year": 2006, "region": "DC", "growthRate": 0.084, "taxRate": 0.0056 },
  { "year": 2006, "region": "DE", "growthRate": 0.049, "taxRate": 0.0043 },
  { "year": 2006, "region": "FL", "growthRate": -0.035, "taxRate": 0.0111 },
  { "year": 2006, "region": "GA", "growthRate": 0.033, "taxRate": 0.0085 },
  { "year": 2006, "region": "HI", "growthRate": 0.069, "taxRate": 0.0026 },
  { "year": 2006, "region": "ID", "growthRate": 0.127, "taxRate": 0.0075 },
  { "year": 2006, "region": "IL", "growthRate": 0.033, "taxRate": 0.0173 },
  { "year": 2006, "region": "IN", "growthRate": 0.016, "taxRate": 0.0071 },
  { "year": 2006, "region": "KS", "growthRate": 0.035, "taxRate": 0.0128 },
  { "year": 2006, "region": "KY", "growthRate": 0.037, "taxRate": 0.0074 },
  { "year": 2006, "region": "MA", "growthRate": -0.024, "taxRate": 0.0102 },
  { "year": 2006, "region": "MI", "growthRate": -0.027, "taxRate": 0.0158 },
  { "year": 2006, "region": "NE", "growthRate": 0.033, "taxRate": 0.0176 },
  { "year": 2006, "region": "NV", "growthRate": 0, "taxRate": 0.0079 },
  { "year": 2006, "region": "OH", "growthRate": 0.025, "taxRate": 0.0134 },
  { "year": 2006, "region": "SC", "growthRate": 0.053, "taxRate": 0.0048 },
  { "year": 2006, "region": "WA", "growthRate": 0.124, "taxRate": 0.0096 },
  { "year": 2007, "region": "AK", "growthRate": 0.033, "taxRate": 0.0103 },
  { "year": 2007, "region": "AL", "growthRate": 0.001, "taxRate": 0.0033 },
  { "year": 2007, "region": "AR", "growthRate": 0.001, "taxRate": 0.0053 },
  { "year": 2007, "region": "AZ", "growthRate": -0.111, "taxRate": 0.0066 },
  { "year": 2007, "region": "CA", "growthRate": -0.085, "taxRate": 0.0077 },
  { "year": 2007, "region": "CO", "growthRate": -0.012, "taxRate": 0.0061 },
  { "year": 2007, "region": "CT", "growthRate": -0.023, "taxRate": 0.0163 },
  { "year": 2007, "region": "DC", "growthRate": -0.01, "taxRate": 0.0056 },
  { "year": 2007, "region": "DE", "growthRate": -0.013, "taxRate": 0.0045 },
  { "year": 2007, "region": "FL", "growthRate": -0.129, "taxRate": 0.0112 },
  { "year": 2007, "region": "GA", "growthRate": -0.037, "taxRate": 0.0087 },
  { "year": 2007, "region": "HI", "growthRate": -0.018, "taxRate": 0.0027 },
  { "year": 2007, "region": "ID", "growthRate": 0.02, "taxRate": 0.0073 },
  { "year": 2007, "region": "IL", "growthRate": -0.022, "taxRate": 0.0178 },
  { "year": 2007, "region": "IN", "growthRate": -0.018, "taxRate": 0.0075 },
  { "year": 2007, "region": "KS", "growthRate": 0.011, "taxRate": 0.0132 },
  { "year": 2007, "region": "KY", "growthRate": 0.017, "taxRate": 0.0075 },
  { "year": 2007, "region": "MA", "growthRate": -0.027, "taxRate": 0.0102 },
  { "year": 2007, "region": "MI", "growthRate": -0.065, "taxRate": 0.0163 },
  { "year": 2007, "region": "NE", "growthRate": 0.013, "taxRate": 0.0179 },
  { "year": 2007, "region": "NV", "growthRate": -0.157, "taxRate": 0.0073 },
  { "year": 2007, "region": "OH", "growthRate": -0.023, "taxRate": 0.0138 },
  { "year": 2007, "region": "SC", "growthRate": 0.004, "taxRate": 0.0048 },
  { "year": 2007, "region": "WA", "growthRate": 0.022, "taxRate": 0.0092 },
  { "year": 2008, "region": "AK", "growthRate": -0.019, "taxRate": 0.0104 },
  { "year": 2008, "region": "AL", "growthRate": -0.049, "taxRate": 0.0035 },
  { "year": 2008, "region": "AR", "growthRate": -0.049, "taxRate": 0.0055 },
  { "year": 2008, "region": "AZ", "growthRate": -0.235, "taxRate": 0.0072 },
  { "year": 2008, "region": "CA", "growthRate": -0.236, "taxRate": 0.0078 },
  { "year": 2008, "region": "CO", "growthRate": -0.06, "taxRate": 0.0061 },
  { "year": 2008, "region": "CT", "growthRate": -0.07, "taxRate": 0.017 },
  { "year": 2008, "region": "DC", "growthRate": -0.105, "taxRate": 0.0056 },
  { "year": 2008, "region": "DE", "growthRate": -0.05, "taxRate": 0.0048 },
  { "year": 2008, "region": "FL", "growthRate": -0.251, "taxRate": 0.011 },
  { "year": 2008, "region": "GA", "growthRate": -0.101, "taxRate": 0.009 },
  { "year": 2008, "region": "HI", "growthRate": -0.104, "taxRate": 0.0028 },
  { "year": 2008, "region": "ID", "growthRate": -0.077, "taxRate": 0.0072 },
  { "year": 2008, "region": "IL", "growthRate": -0.091, "taxRate": 0.0186 },
  { "year": 2008, "region": "IN", "growthRate": -0.057, "taxRate": 0.0081 },
  { "year": 2008, "region": "KS", "growthRate": -0.023, "taxRate": 0.0136 },
  { "year": 2008, "region": "KY", "growthRate": -0.027, "taxRate": 0.0078 },
  { "year": 2008, "region": "MA", "growthRate": -0.105, "taxRate": 0.0105 },
  { "year": 2008, "region": "MI", "growthRate": -0.144, "taxRate": 0.0171 },
  { "year": 2008, "region": "NE", "growthRate": -0.02, "taxRate": 0.0183 },
  { "year": 2008, "region": "NV", "growthRate": -0.311, "taxRate": 0.0076 },
  { "year": 2008, "region": "OH", "growthRate": -0.069, "taxRate": 0.0144 },
  { "year": 2008, "region": "SC", "growthRate": -0.067, "taxRate": 0.0051 },
  { "year": 2008, "region": "WA", "growthRate": -0.111, "taxRate": 0.0094 },
  { "year": 2009, "region": "AK", "growthRate": -0.013, "taxRate": 0.0105 },
  { "year": 2009, "region": "AL", "growthRate": -0.024, "taxRate": 0.0037 },
  { "year": 2009, "region": "AR", "growthRate": -0.024, "taxRate": 0.0057 },
  { "year": 2009, "region": "AZ", "growthRate": -0.155, "taxRate": 0.0077 },
  { "year": 2009, "region": "CA", "growthRate": -0.102, "taxRate": 0.0079 },
  { "year": 2009, "region": "CO", "growthRate": -0.018, "taxRate": 0.0061 },
  { "year": 2009, "region": "CT", "growthRate": -0.029, "taxRate": 0.0181 },
  { "year": 2009, "region": "DC", "growthRate": -0.035, "taxRate": 0.0056 },
  { "year": 2009, "region": "DE", "growthRate": -0.03, "taxRate": 0.0051 },
  { "year": 2009, "region": "FL", "growthRate": -0.111, "taxRate": 0.0108 },
  { "year": 2009, "region": "GA", "growthRate": -0.058, "taxRate": 0.0092 },
  { "year": 2009, "region": "HI", "growthRate": -0.081, "taxRate": 0.0029 },
  { "year": 2009, "region": "ID", "growthRate": -0.078, "taxRate": 0.0074 },
  { "year": 2009, "region": "IL", "growthRate": -0.041, "taxRate": 0.0193 },
  { "year": 2009, "region": "IN", "growthRate": -0.023, "taxRate": 0.0085 },
  { "year": 2009, "region": "KS", "growthRate": -0.012, "taxRate": 0.0139 },
  { "year": 2009, "region": "KY", "growthRate": -0.007, "taxRate": 0.0081 },
  { "year": 2009, "region": "MA", "growthRate": 0.008, "taxRate": 0.0111 },
  { "year": 2009, "region": "MI", "growthRate": -0.045, "taxRate": 0.0178 },
  { "year": 2009, "region": "NE", "growthRate": -0.01, "taxRate": 0.0184 },
  { "year": 2009, "region": "NV", "growthRate": -0.247, "taxRate": 0.0085 },
  { "year": 2009, "region": "OH", "growthRate": -0.028, "taxRate": 0.0152 },
  { "year": 2009, "region": "SC", "growthRate": -0.044, "taxRate": 0.0054 },
  { "year": 2009, "region": "WA", "growthRate": -0.092, "taxRate": 0.0103 },
  { "year": 2010, "region": "AK", "growthRate": 0.002, "taxRate": 0.0111 },
  { "year": 2010, "region": "AL", "growthRate": -0.03, "taxRate": 0.0039 },
  { "year": 2010, "region": "AR", "growthRate": -0.03, "taxRate": 0.0059 },
  { "year": 2010, "region": "AZ", "growthRate": -0.089, "taxRate": 0.008 },
  { "year": 2010, "region": "CA", "growthRate": 0.011, "taxRate": 0.0081 },
  { "year": 2010, "region": "CO", "growthRate": -0.036, "taxRate": 0.0061 },
  { "year": 2010, "region": "CT", "growthRate": -0.03, "taxRate": 0.019 },
  { "year": 2010, "region": "DC", "growthRate": -0.018, "taxRate": 0.0056 },
  { "year": 2010, "region": "DE", "growthRate": -0.032, "taxRate": 0.0053 },
  { "year": 2010, "region": "FL", "growthRate": -0.08, "taxRate": 0.0106 },
  { "year": 2010, "region": "GA", "growthRate": -0.043, "taxRate": 0.0092 },
  { "year": 2010, "region": "HI", "growthRate": -0.04, "taxRate": 0.003 },
  { "year": 2010, "region": "ID", "growthRate": -0.052, "taxRate": 0.0075 },
  { "year": 2010, "region": "IL", "growthRate": -0.038, "taxRate": 0.0197 },
  { "year": 2010, "region": "IN", "growthRate": -0.03, "taxRate": 0.0086 },
  { "year": 2010, "region": "KS", "growthRate": -0.015, "taxRate": 0.0139 },
  { "year": 2010, "region": "KY", "growthRate": -0.012, "taxRate": 0.0083 },
  { "year": 2010, "region": "MA", "growthRate": -0.016, "taxRate": 0.0115 },
  { "year": 2010, "region": "MI", "growthRate": -0.039, "taxRate": 0.018 },
  { "year": 2010, "region": "NE", "growthRate": -0.013, "taxRate": 0.0183 },
  { "year": 2010, "region": "NV", "growthRate": -0.17, "taxRate": 0.0094 },
  { "year": 2010, "region": "OH", "growthRate": -0.022, "taxRate": 0.0154 },
  { "year": 2010, "region": "SC", "growthRate": -0.031, "taxRate": 0.0055 },
  { "year": 2010, "region": "WA", "growthRate": -0.081, "taxRate": 0.0109 },
  { "year": 2011, "region": "AK", "growthRate": 0.006, "taxRate": 0.0118 },
  { "year": 2011, "region": "AL", "growthRate": -0.038, "taxRate": 0.004 },
  { "year": 2011, "region": "AR", "growthRate": -0.038, "taxRate": 0.0061 },
  { "year": 2011, "region": "AZ", "growthRate": -0.063, "taxRate": 0.008 },
  { "year": 2011, "region": "CA", "growthRate": -0.069, "taxRate": 0.008 },
  { "year": 2011, "region": "CO", "growthRate": -0.02, "taxRate": 0.0061 },
  { "year": 2011, "region": "CT", "growthRate": -0.043, "taxRate": 0.0198 },
  { "year": 2011, "region": "DC", "growthRate": -0.032, "taxRate": 0.0056 },
  { "year": 2011, "region": "DE", "growthRate": -0.032, "taxRate": 0.0053 },
  { "year": 2011, "region": "FL", "growthRate": -0.089, "taxRate": 0.0102 },
  { "year": 2011, "region": "GA", "growthRate": -0.043, "taxRate": 0.0091 },
  { "year": 2011, "region": "HI", "growthRate": -0.036, "taxRate": 0.0031 },
  { "year": 2011, "region": "ID", "growthRate": -0.048, "taxRate": 0.0075 },
  { "year": 2011, "region": "IL", "growthRate": -0.053, "taxRate": 0.0203 },
  { "year": 2011, "region": "IN", "growthRate": -0.029, "taxRate": 0.0086 },
  { "year": 2011, "region": "KS", "growthRate": -0.013, "taxRate": 0.014 },
  { "year": 2011, "region": "KY", "growthRate": -0.023, "taxRate": 0.0085 },
  { "year": 2011, "region": "MA", "growthRate": -0.024, "taxRate": 0.0117 },
  { "year": 2011, "region": "MI", "growthRate": -0.053, "taxRate": 0.0183 },
  { "year": 2011, "region": "NE", "growthRate": -0.011, "taxRate": 0.0184 },
  { "year": 2011, "region": "NV", "growthRate": -0.146, "taxRate": 0.0094 },
  { "year": 2011, "region": "OH", "growthRate": -0.032, "taxRate": 0.0158 },
  { "year": 2011, "region": "SC", "growthRate": -0.032, "taxRate": 0.0056 },
  { "year": 2011, "region": "WA", "growthRate": -0.07, "taxRate": 0.0108 },
  { "year": 2012, "region": "AK", "growthRate": 0.014, "taxRate": 0.0119 },
  { "year": 2012, "region": "AL", "growthRate": 0.003, "taxRate": 0.0042 },
  { "year": 2012, "region": "AR", "growthRate": 0.003, "taxRate": 0.0061 },
  { "year": 2012, "region": "AZ", "growthRate": 0.133, "taxRate": 0.0078 },
  { "year": 2012, "region": "CA", "growthRate": 0.08, "taxRate": 0.0077 },
  { "year": 2012, "region": "CO", "growthRate": 0.076, "taxRate": 0.0061 },
  { "year": 2012, "region": "CT", "growthRate": -0.011, "taxRate": 0.02 },
  { "year": 2012, "region": "DC", "growthRate": 0.056, "taxRate": 0.0056 },
  { "year": 2012, "region": "DE", "growthRate": 0.005, "taxRate": 0.0053 },
  { "year": 2012, "region": "FL", "growthRate": 0.068, "taxRate": 0.0098 },
  { "year": 2012, "region": "GA", "growthRate": 0.028, "taxRate": 0.0088 },
  { "year": 2012, "region": "HI", "growthRate": 0.037, "taxRate": 0.0031 },
  { "year": 2012, "region": "ID", "growthRate": 0.077, "taxRate": 0.0075 },
  { "year": 2012, "region": "IL", "growthRate": 0.002, "taxRate": 0.0214 },
  { "year": 2012, "region": "IN", "growthRate": 0.027, "taxRate": 0.0085 },
  { "year": 2012, "region": "KS", "growthRate": 0.016, "taxRate": 0.0139 },
  { "year": 2012, "region": "KY", "growthRate": 0.012, "taxRate": 0.0085 },
  { "year": 2012, "region": "MA", "growthRate": 0.014, "taxRate": 0.0118 },
  { "year": 2012, "region": "MI", "growthRate": 0.045, "taxRate": 0.0183 },
  { "year": 2012, "region": "NE", "growthRate": 0.024, "taxRate": 0.0184 },
  { "year": 2012, "region": "NV", "growthRate": 0.173, "taxRate": 0.0088 },
  { "year": 2012, "region": "OH", "growthRate": 0.016, "taxRate": 0.0158 },
  { "year": 2012, "region": "SC", "growthRate": 0.015, "taxRate": 0.0056 },
  { "year": 2012, "region": "WA", "growthRate": 0.058, "taxRate": 0.0105 },
  { "year": 2013, "region": "AK", "growthRate": 0.028, "taxRate": 0.0119 },
  { "year": 2013, "region": "AL", "growthRate": 0.044, "taxRate": 0.0042 },
  { "year": 2013, "region": "AR", "growthRate": 0.044, "taxRate": 0.0061 },
  { "year": 2013, "region": "AZ", "growthRate": 0.202, "taxRate": 0.0077 },
  { "year": 2013, "region": "CA", "growthRate": 0.226, "taxRate": 0.0077 },
  { "year": 2013, "region": "CO", "growthRate": 0.105, "taxRate": 0.006 },
  { "year": 2013, "region": "CT", "growthRate": 0.036, "taxRate": 0.0202 },
  { "year": 2013, "region": "DC", "growthRate": 0.086, "taxRate": 0.0057 },
  { "year": 2013, "region": "DE", "growthRate": 0.035, "taxRate": 0.0054 },
  { "year": 2013, "region": "FL", "growthRate": 0.152, "taxRate": 0.0097 },
  { "year": 2013, "region": "GA", "growthRate": 0.098, "taxRate": 0.0087 },
  { "year": 2013, "region": "HI", "growthRate": 0.082, "taxRate": 0.003 },
  { "year": 2013, "region": "ID", "growthRate": 0.106, "taxRate": 0.0073 },
  { "year": 2013, "region": "IL", "growthRate": 0.065, "taxRate": 0.0221 },
  { "year": 2013, "region": "IN", "growthRate": 0.062, "taxRate": 0.0084 },
  { "year": 2013, "region": "KS", "growthRate": 0.031, "taxRate": 0.0139 },
  { "year": 2013, "region": "KY", "growthRate": 0.031, "taxRate": 0.0085 },
  { "year": 2013, "region": "MA", "growthRate": 0.079, "taxRate": 0.0119 },
  { "year": 2013, "region": "MI", "growthRate": 0.096, "taxRate": 0.0178 },
  { "year": 2013, "region": "NE", "growthRate": 0.043, "taxRate": 0.0184 },
  { "year": 2013, "region": "NV", "growthRate": 0.268, "taxRate": 0.0084 },
  { "year": 2013, "region": "OH", "growthRate": 0.036, "taxRate": 0.0157 },
  { "year": 2013, "region": "SC", "growthRate": 0.051, "taxRate": 0.0056 },
  { "year": 2013, "region": "WA", "growthRate": 0.112, "taxRate": 0.0102 },
  { "year": 2014, "region": "AK", "growthRate": 0.023, "taxRate": 0.0118 },
  { "year": 2014, "region": "AL", "growthRate": 0.024, "taxRate": 0.0042 },
  { "year": 2014, "region": "AR", "growthRate": 0.024, "taxRate": 0.0061 },
  { "year": 2014, "region": "AZ", "growthRate": 0.072, "taxRate": 0.0073 },
  { "year": 2014, "region": "CA", "growthRate": 0.094, "taxRate": 0.0077 },
  { "year": 2014, "region": "CO", "growthRate": 0.082, "taxRate": 0.0059 },
  { "year": 2014, "region": "CT", "growthRate": 0.004, "taxRate": 0.0204 },
  { "year": 2014, "region": "DC", "growthRate": 0.021, "taxRate": 0.0057 },
  { "year": 2014, "region": "DE", "growthRate": 0.013, "taxRate": 0.0055 },
  { "year": 2014, "region": "FL", "growthRate": 0.059, "taxRate": 0.0097 },
  { "year": 2014, "region": "GA", "growthRate": 0.049, "taxRate": 0.0087 },
  { "year": 2014, "region": "HI", "growthRate": 0.048, "taxRate": 0.0029 },
  { "year": 2014, "region": "ID", "growthRate": 0.056, "taxRate": 0.007 },
  { "year": 2014, "region": "IL", "growthRate": 0.03, "taxRate": 0.0225 },
  { "year": 2014, "region": "IN", "growthRate": 0.036, "taxRate": 0.0084 },
  { "year": 2014, "region": "KS", "growthRate": 0.026, "taxRate": 0.0137 },
  { "year": 2014, "region": "KY", "growthRate": 0.033, "taxRate": 0.0084 },
  { "year": 2014, "region": "MA", "growthRate": 0.038, "taxRate": 0.012 },
  { "year": 2014, "region": "MI", "growthRate": 0.049, "taxRate": 0.0173 },
  { "year": 2014, "region": "NE", "growthRate": 0.039, "taxRate": 0.0183 },
  { "year": 2014, "region": "NV", "growthRate": 0.103, "taxRate": 0.008 },
  { "year": 2014, "region": "OH", "growthRate": 0.033, "taxRate": 0.0155 },
  { "year": 2014, "region": "SC", "growthRate": 0.042, "taxRate": 0.0056 },
  { "year": 2014, "region": "WA", "growthRate": 0.067, "taxRate": 0.0099 },
  { "year": 2015, "region": "AK", "growthRate": 0.019, "taxRate": 0.0118 },
  { "year": 2015, "region": "AL", "growthRate": 0.034, "taxRate": 0.0042 },
  { "year": 2015, "region": "AR", "growthRate": 0.034, "taxRate": 0.0062 },
  { "year": 2015, "region": "AZ", "growthRate": 0.064, "taxRate": 0.0072 },
  { "year": 2015, "region": "CA", "growthRate": 0.078, "taxRate": 0.0076 },
  { "year": 2015, "region": "CO", "growthRate": 0.122, "taxRate": 0.0057 },
  { "year": 2015, "region": "CT", "growthRate": 0.013, "taxRate": 0.0207 },
  { "year": 2015, "region": "DC", "growthRate": 0.037, "taxRate": 0.0057 },
  { "year": 2015, "region": "DE", "growthRate": 0.022, "taxRate": 0.0055 },
  { "year": 2015, "region": "FL", "growthRate": 0.097, "taxRate": 0.0097 },
  { "year": 2015, "region": "GA", "growthRate": 0.063, "taxRate": 0.0087 },
  { "year": 2015, "region": "HI", "growthRate": 0.056, "taxRate": 0.0028 },
  { "year": 2015, "region": "ID", "growthRate": 0.066, "taxRate": 0.0069 },
  { "year": 2015, "region": "IL", "growthRate": 0.029, "taxRate": 0.0228 },
  { "year": 2015, "region": "IN", "growthRate": 0.044, "taxRate": 0.0083 },
  { "year": 2015, "region": "KS", "growthRate": 0.028, "taxRate": 0.0139 },
  { "year": 2015, "region": "KY", "growthRate": 0.041, "taxRate": 0.0083 },
  { "year": 2015, "region": "MA", "growthRate": 0.046, "taxRate": 0.0121 },
  { "year": 2015, "region": "MI", "growthRate": 0.06, "taxRate": 0.0168 },
  { "year": 2015, "region": "NE", "growthRate": 0.045, "taxRate": 0.0185 },
  { "year": 2015, "region": "NV", "growthRate": 0.099, "taxRate": 0.0077 },
  { "year": 2015, "region": "OH", "growthRate": 0.043, "taxRate": 0.0154 },
  { "year": 2015, "region": "SC", "growthRate": 0.053, "taxRate": 0.0056 },
  { "year": 2015, "region": "WA", "growthRate": 0.096, "taxRate": 0.0095 },
  { "year": 2016, "region": "AK", "growthRate": 0.011, "taxRate": 0.0118 },
  { "year": 2016, "region": "AL", "growthRate": 0.042, "taxRate": 0.0041 },
  { "year": 2016, "region": "AR", "growthRate": 0.042, "taxRate": 0.0062 },
  { "year": 2016, "region": "AZ", "growthRate": 0.066, "taxRate": 0.0069 },
  { "year": 2016, "region": "CA", "growthRate": 0.065, "taxRate": 0.0075 },
  { "year": 2016, "region": "CO", "growthRate": 0.102, "taxRate": 0.0055 },
  { "year": 2016, "region": "CT", "growthRate": 0.02, "taxRate": 0.0211 },
  { "year": 2016, "region": "DC", "growthRate": 0.035, "taxRate": 0.0057 },
  { "year": 2016, "region": "DE", "growthRate": 0.031, "taxRate": 0.0056 },
  { "year": 2016, "region": "FL", "growthRate": 0.095, "taxRate": 0.0094 },
  { "year": 2016, "region": "GA", "growthRate": 0.065, "taxRate": 0.0087 },
  { "year": 2016, "region": "HI", "growthRate": 0.054, "taxRate": 0.0028 },
  { "year": 2016, "region": "ID", "growthRate": 0.076, "taxRate": 0.0067 },
  { "year": 2016, "region": "IL", "growthRate": 0.036, "taxRate": 0.0229 },
  { "year": 2016, "region": "IN", "growthRate": 0.052, "taxRate": 0.0082 },
  { "year": 2016, "region": "KS", "growthRate": 0.039, "taxRate": 0.014 },
  { "year": 2016, "region": "KY", "growthRate": 0.052, "taxRate": 0.0083 },
  { "year": 2016, "region": "MA", "growthRate": 0.054, "taxRate": 0.012 },
  { "year": 2016, "region": "MI", "growthRate": 0.065, "taxRate": 0.0164 },
  { "year": 2016, "region": "NE", "growthRate": 0.051, "taxRate": 0.0182 },
  { "year": 2016, "region": "NV", "growthRate": 0.089, "taxRate": 0.0073 },
  { "year": 2016, "region": "OH", "growthRate": 0.049, "taxRate": 0.0156 },
  { "year": 2016, "region": "SC", "growthRate": 0.06, "taxRate": 0.0057 },
  { "year": 2016, "region": "WA", "growthRate": 0.112, "taxRate": 0.0093 },
  { "year": 2017, "region": "AK", "growthRate": 0.015, "taxRate": 0.0118 },
  { "year": 2017, "region": "AL", "growthRate": 0.049, "taxRate": 0.004 },
  { "year": 2017, "region": "AR", "growthRate": 0.049, "taxRate": 0.0062 },
  { "year": 2017, "region": "AZ", "growthRate": 0.082, "taxRate": 0.0066 },
  { "year": 2017, "region": "CA", "growthRate": 0.07, "taxRate": 0.0076 },
  { "year": 2017, "region": "CO", "growthRate": 0.089, "taxRate": 0.0053 },
  { "year": 2017, "region": "CT", "growthRate": 0.027, "taxRate": 0.0214 },
  { "year": 2017, "region": "DC", "growthRate": 0.035, "taxRate": 0.0057 },
  { "year": 2017, "region": "DE", "growthRate": 0.042, "taxRate": 0.0056 },
  { "year": 2017, "region": "FL", "growthRate": 0.086, "taxRate": 0.0091 },
  { "year": 2017, "region": "GA", "growthRate": 0.066, "taxRate": 0.0087 },
  { "year": 2017, "region": "HI", "growthRate": 0.051, "taxRate": 0.0028 },
  { "year": 2017, "region": "ID", "growthRate": 0.093, "taxRate": 0.0065 },
  { "year": 2017, "region": "IL", "growthRate": 0.039, "taxRate": 0.0222 },
  { "year": 2017, "region": "IN", "growthRate": 0.058, "taxRate": 0.0081 },
  { "year": 2017, "region": "KS", "growthRate": 0.048, "taxRate": 0.0137 },
  { "year": 2017, "region": "KY", "growthRate": 0.055, "taxRate": 0.0082 },
  { "year": 2017, "region": "MA", "growthRate": 0.06, "taxRate": 0.012 },
  { "year": 2017, "region": "MI", "growthRate": 0.069, "taxRate": 0.0159 },
  { "year": 2017, "region": "NE", "growthRate": 0.059, "taxRate": 0.0176 },
  { "year": 2017, "region": "NV", "growthRate": 0.134, "taxRate": 0.0069 },
  { "year": 2017, "region": "OH", "growthRate": 0.057, "taxRate": 0.0156 },
  { "year": 2017, "region": "SC", "growthRate": 0.062, "taxRate": 0.0057 },
  { "year": 2017, "region": "WA", "growthRate": 0.123, "taxRate": 0.0092 },
  { "year": 2018, "region": "AK", "growthRate": 0.028, "taxRate": 0.0119 },
  { "year": 2018, "region": "AL", "growthRate": 0.056, "taxRate": 0.004 },
  { "year": 2018, "region": "AR", "growthRate": 0.056, "taxRate": 0.0061 },
  { "year": 2018, "region": "AZ", "growthRate": 0.084, "taxRate": 0.0063 },
  { "year": 2018, "region": "CA", "growthRate": 0.047, "taxRate": 0.0075 },
  { "year": 2018, "region": "CO", "growthRate": 0.072, "taxRate": 0.0052 },
  { "year": 2018, "region": "CT", "growthRate": 0.02, "taxRate": 0.0215 },
  { "year": 2018, "region": "DC", "growthRate": 0.037, "taxRate": 0.0056 },
  { "year": 2018, "region": "DE", "growthRate": 0.049, "taxRate": 0.0056 },
  { "year": 2018, "region": "FL", "growthRate": 0.075, "taxRate": 0.0089 },
  { "year": 2018, "region": "GA", "growthRate": 0.067, "taxRate": 0.0087 },
  { "year": 2018, "region": "HI", "growthRate": 0.043, "taxRate": 0.0028 },
  { "year": 2018, "region": "ID", "growthRate": 0.107, "taxRate": 0.0063 },
  { "year": 2018, "region": "IL", "growthRate": 0.032, "taxRate": 0.0216 },
  { "year": 2018, "region": "IN", "growthRate": 0.059, "taxRate": 0.0081 },
  { "year": 2018, "region": "KS", "growthRate": 0.053, "taxRate": 0.0137 },
  { "year": 2018, "region": "KY", "growthRate": 0.053, "taxRate": 0.0082 },
  { "year": 2018, "region": "MA", "growthRate": 0.057, "taxRate": 0.0117 },
  { "year": 2018, "region": "MI", "growthRate": 0.062, "taxRate": 0.0154 },
  { "year": 2018, "region": "NE", "growthRate": 0.059, "taxRate": 0.0173 },
  { "year": 2018, "region": "NV", "growthRate": 0.121, "taxRate": 0.0065 },
  { "year": 2018, "region": "OH", "growthRate": 0.054, "taxRate": 0.0156 },
  { "year": 2018, "region": "SC", "growthRate": 0.064, "taxRate": 0.0056 },
  { "year": 2018, "region": "WA", "growthRate": 0.068, "taxRate": 0.0101 },
  { "year": 2019, "region": "AK", "growthRate": 0.026, "taxRate": 0.0116 },
  { "year": 2019, "region": "AL", "growthRate": 0.052, "taxRate": 0.0038 },
  { "year": 2019, "region": "AR", "growthRate": 0.052, "taxRate": 0.0061 },
  { "year": 2019, "region": "AZ", "growthRate": 0.08, "taxRate": 0.0062 },
  { "year": 2019, "region": "CA", "growthRate": 0.047, "taxRate": 0.0074 },
  { "year": 2019, "region": "CO", "growthRate": 0.053, "taxRate": 0.0051 },
  { "year": 2019, "region": "CT", "growthRate": 0.021, "taxRate": 0.0214 },
  { "year": 2019, "region": "DC", "growthRate": 0.036, "taxRate": 0.0055 },
  { "year": 2019, "region": "DE", "growthRate": 0.043, "taxRate": 0.0056 },
  { "year": 2019, "region": "FL", "growthRate": 0.053, "taxRate": 0.0086 },
  { "year": 2019, "region": "GA", "growthRate": 0.062, "taxRate": 0.0087 },
  { "year": 2019, "region": "HI", "growthRate": 0.025, "taxRate": 0.0028 },
  { "year": 2019, "region": "ID", "growthRate": 0.062, "taxRate": 0.0063 },
  { "year": 2019, "region": "IL", "growthRate": 0.028, "taxRate": 0.0207 },
  { "year": 2019, "region": "IN", "growthRate": 0.059, "taxRate": 0.0081 },
  { "year": 2019, "region": "KS", "growthRate": 0.05, "taxRate": 0.0133 },
  { "year": 2019, "region": "KY", "growthRate": 0.05, "taxRate": 0.008 },
  { "year": 2019, "region": "MA", "growthRate": 0.046, "taxRate": 0.0114 },
  { "year": 2019, "region": "MI", "growthRate": 0.051, "taxRate": 0.0148 },
  { "year": 2019, "region": "NE", "growthRate": 0.055, "taxRate": 0.0167 },
  { "year": 2019, "region": "NV", "growthRate": 0.045, "taxRate": 0.006 },
  { "year": 2019, "region": "OH", "growthRate": 0.054, "taxRate": 0.0154 },
  { "year": 2019, "region": "SC", "growthRate": 0.055, "taxRate": 0.0055 },
  { "year": 2019, "region": "WA", "growthRate": 0.069, "taxRate": 0.0093 },
  { "year": 2020, "region": "AK", "growthRate": 0.049, "taxRate": 0.0112 },
  { "year": 2020, "region": "AL", "growthRate": 0.078, "taxRate": 0.0037 },
  { "year": 2020, "region": "AR", "growthRate": 0.078, "taxRate": 0.0061 },
  { "year": 2020, "region": "AZ", "growthRate": 0.118, "taxRate": 0.006 },
  { "year": 2020, "region": "CA", "growthRate": 0.09, "taxRate": 0.0073 },
  { "year": 2020, "region": "CO", "growthRate": 0.105, "taxRate": 0.0049 },
  { "year": 2020, "region": "CT", "growthRate": 0.104, "taxRate": 0.0207 },
  { "year": 2020, "region": "DC", "growthRate": 0.094, "taxRate": 0.0056 },
  { "year": 2020, "region": "DE", "growthRate": 0.084, "taxRate": 0.0056 },
  { "year": 2020, "region": "FL", "growthRate": 0.098, "taxRate": 0.0083 },
  { "year": 2020, "region": "GA", "growthRate": 0.097, "taxRate": 0.0087 },
  { "year": 2020, "region": "HI", "growthRate": 0.054, "taxRate": 0.0028 },
  { "year": 2020, "region": "ID", "growthRate": 0.128, "taxRate": 0.006 },
  { "year": 2020, "region": "IL", "growthRate": 0.066, "taxRate": 0.0205 },
  { "year": 2020, "region": "IN", "growthRate": 0.093, "taxRate": 0.0081 },
  { "year": 2020, "region": "KS", "growthRate": 0.069, "taxRate": 0.0133 },
  { "year": 2020, "region": "KY", "growthRate": 0.078, "taxRate": 0.008 },
  { "year": 2020, "region": "MA", "growthRate": 0.107, "taxRate": 0.0112 },
  { "year": 2020, "region": "MI", "growthRate": 0.101, "taxRate": 0.0144 },
  { "year": 2020, "region": "NE", "growthRate": 0.089, "taxRate": 0.0161 },
  { "year": 2020, "region": "NV", "growthRate": 0.103, "taxRate": 0.0055 },
  { "year": 2020, "region": "OH", "growthRate": 0.084, "taxRate": 0.0154 },
  { "year": 2020, "region": "SC", "growthRate": 0.094, "taxRate": 0.0056 },
  { "year": 2020, "region": "WA", "growthRate": 0.113, "taxRate": 0.0091 },
  { "year": 2021, "region": "AK", "growthRate": 0.116, "taxRate": 0.0109 },
  { "year": 2021, "region": "AL", "growthRate": 0.163, "taxRate": 0.0037 },
  { "year": 2021, "region": "AR", "growthRate": 0.163, "taxRate": 0.0061 },
  { "year": 2021, "region": "AZ", "growthRate": 0.273, "taxRate": 0.0057 },
  { "year": 2021, "region": "CA", "growthRate": 0.182, "taxRate": 0.0071 },
  { "year": 2021, "region": "CO", "growthRate": 0.202, "taxRate": 0.0048 },
  { "year": 2021, "region": "CT", "growthRate": 0.147, "taxRate": 0.017 },
  { "year": 2021, "region": "DC", "growthRate": 0.111, "taxRate": 0.0057 },
  { "year": 2021, "region": "DE", "growthRate": 0.15, "taxRate": 0.0056 },
  { "year": 2021, "region": "FL", "growthRate": 0.26, "taxRate": 0.008 },
  { "year": 2021, "region": "GA", "growthRate": 0.204, "taxRate": 0.0087 },
  { "year": 2021, "region": "HI", "growthRate": 0.166, "taxRate": 0.0027 },
  { "year": 2021, "region": "ID", "growthRate": 0.27, "taxRate": 0.0056 },
  { "year": 2021, "region": "IL", "growthRate": 0.12, "taxRate": 0.0197 },
  { "year": 2021, "region": "IN", "growthRate": 0.165, "taxRate": 0.0081 },
  { "year": 2021, "region": "KS", "growthRate": 0.115, "taxRate": 0.0133 },
  { "year": 2021, "region": "KY", "growthRate": 0.136, "taxRate": 0.0078 },
  { "year": 2021, "region": "MA", "growthRate": 0.13, "taxRate": 0.0112 },
  { "year": 2021, "region": "MI", "growthRate": 0.149, "taxRate": 0.0132 },
  { "year": 2021, "region": "NE", "growthRate": 0.142, "taxRate": 0.0161 },
  { "year": 2021, "region": "NV", "growthRate": 0.235, "taxRate": 0.0053 },
  { "year": 2021, "region": "OH", "growthRate": 0.147, "taxRate": 0.0149 },
  { "year": 2021, "region": "SC", "growthRate": 0.183, "taxRate": 0.0056 },
  { "year": 2021, "region": "WA", "growthRate": 0.21, "taxRate": 0.0085 },
  { "year": 2022, "region": "AK", "growthRate": 0.086, "taxRate": 0.0109 },
  { "year": 2022, "region": "AL", "growthRate": 0.099, "taxRate": 0.0037 },
  { "year": 2022, "region": "AR", "growthRate": 0.099, "taxRate": 0.0061 },
  { "year": 2022, "region": "AZ", "growthRate": 0.099, "taxRate": 0.0057 },
  { "year": 2022, "region": "CA", "growthRate": 0.056, "taxRate": 0.0071 },
  { "year": 2022, "region": "CO", "growthRate": 0.079, "taxRate": 0.0048 },
  { "year": 2022, "region": "CT", "growthRate": 0.082, "taxRate": 0.017 },
  { "year": 2022, "region": "DC", "growthRate": 0.049, "taxRate": 0.0057 },
  { "year": 2022, "region": "DE", "growthRate": 0.094, "taxRate": 0.0056 },
  { "year": 2022, "region": "FL", "growthRate": 0.135, "taxRate": 0.008 },
  { "year": 2022, "region": "GA", "growthRate": 0.112, "taxRate": 0.0087 },
  { "year": 2022, "region": "HI", "growthRate": 0.072, "taxRate": 0.0027 },
  { "year": 2022, "region": "ID", "growthRate": 0.107, "taxRate": 0.0056 },
  { "year": 2022, "region": "IL", "growthRate": 0.069, "taxRate": 0.0197 },
  { "year": 2022, "region": "IN", "growthRate": 0.094, "taxRate": 0.0081 },
  { "year": 2022, "region": "KS", "growthRate": 0.107, "taxRate": 0.0133 },
  { "year": 2022, "region": "KY", "growthRate": 0.1, "taxRate": 0.0078 },
  { "year": 2022, "region": "MA", "growthRate": 0.066, "taxRate": 0.0112 },
  { "year": 2022, "region": "MI", "growthRate": 0.068, "taxRate": 0.0132 },
  { "year": 2022, "region": "NE", "growthRate": 0.104, "taxRate": 0.0161 },
  { "year": 2022, "region": "NV", "growthRate": 0.035, "taxRate": 0.0053 },
  { "year": 2022, "region": "OH", "growthRate": 0.095, "taxRate": 0.0149 },
  { "year": 2022, "region": "SC", "growthRate": 0.128, "taxRate": 0.0056 },
  { "year": 2022, "region": "WA", "growthRate": 0.058, "taxRate": 0.0085 },
  { "year": 2023, "region": "AK", "growthRate": 0.037, "taxRate": 0.0109 },
  { "year": 2023, "region": "AL", "growthRate": 0.058, "taxRate": 0.0037 },
  { "year": 2023, "region": "AR", "growthRate": 0.058, "taxRate": 0.0061 },
  { "year": 2023, "region": "AZ", "growthRate": 0.039, "taxRate": 0.0057 },
  { "year": 2023, "region": "CA", "growthRate": 0.019, "taxRate": 0.0071 },
  { "year": 2023, "region": "CO", "growthRate": 0.024, "taxRate": 0.0048 },
  { "year": 2023, "region": "CT", "growthRate": 0.071, "taxRate": 0.017 },
  { "year": 2023, "region": "DC", "growthRate": 0.018, "taxRate": 0.0057 },
  { "year": 2023, "region": "DE", "growthRate": 0.063, "taxRate": 0.0056 },
  { "year": 2023, "region": "FL", "growthRate": 0.064, "taxRate": 0.008 },
  { "year": 2023, "region": "GA", "growthRate": 0.056, "taxRate": 0.0087 },
  { "year": 2023, "region": "HI", "growthRate": 0.012, "taxRate": 0.0027 },
  { "year": 2023, "region": "ID", "growthRate": 0.014, "taxRate": 0.0056 },
  { "year": 2023, "region": "IL", "growthRate": 0.055, "taxRate": 0.0197 },
  { "year": 2023, "region": "IN", "growthRate": 0.056, "taxRate": 0.0081 },
  { "year": 2023, "region": "KS", "growthRate": 0.064, "taxRate": 0.0133 },
  { "year": 2023, "region": "KY", "growthRate": 0.064, "taxRate": 0.0078 },
  { "year": 2023, "region": "MA", "growthRate": 0.073, "taxRate": 0.0112 },
  { "year": 2023, "region": "MI", "growthRate": 0.06, "taxRate": 0.0132 },
  { "year": 2023, "region": "NE", "growthRate": 0.06, "taxRate": 0.0161 },
  { "year": 2023, "region": "NV", "growthRate": 0.025, "taxRate": 0.0053 },
  { "year": 2023, "region": "OH", "growthRate": 0.062, "taxRate": 0.0149 },
  { "year": 2023, "region": "SC", "growthRate": 0.066, "taxRate": 0.0056 },
  { "year": 2023, "region": "WA", "growthRate": 0.024, "taxRate": 0.0085 },
  { "year": 2024, "region": "AK", "growthRate": 0.022, "taxRate": 0.0109 },
  { "year": 2024, "region": "AL", "growthRate": 0.056, "taxRate": 0.0037 },
  { "year": 2024, "region": "AR", "growthRate": 0.056, "taxRate": 0.0061 },
  { "year": 2024, "region": "AZ", "growthRate": 0.076, "taxRate": 0.0057 },
  { "year": 2024, "region": "CA", "growthRate": 0.068, "taxRate": 0.0071 },
  { "year": 2024, "region": "CO", "growthRate": 0.038, "taxRate": 0.0048 },
  { "year": 2024, "region": "CT", "growthRate": 0.079, "taxRate": 0.017 },
  { "year": 2024, "region": "DC", "growthRate": 0.039, "taxRate": 0.0057 },
  { "year": 2024, "region": "DE", "growthRate": 0.062, "taxRate": 0.0056 },
  { "year": 2024, "region": "FL", "growthRate": 0.064, "taxRate": 0.008 },
  { "year": 2024, "region": "GA", "growthRate": 0.059, "taxRate": 0.0087 },
  { "year": 2024, "region": "HI", "growthRate": 0.024, "taxRate": 0.0027 },
  { "year": 2024, "region": "ID", "growthRate": 0.007, "taxRate": 0.0056 },
  { "year": 2024, "region": "IL", "growthRate": 0.058, "taxRate": 0.0197 },
  { "year": 2024, "region": "IN", "growthRate": 0.059, "taxRate": 0.0081 },
  { "year": 2024, "region": "KS", "growthRate": 0.066, "taxRate": 0.0133 },
  { "year": 2024, "region": "KY", "growthRate": 0.065, "taxRate": 0.0078 },
  { "year": 2024, "region": "MA", "growthRate": 0.072, "taxRate": 0.0112 },
  { "year": 2024, "region": "MI", "growthRate": 0.059, "taxRate": 0.0132 },
  { "year": 2024, "region": "NE", "growthRate": 0.06, "taxRate": 0.0161 },
  { "year": 2024, "region": "NV", "growthRate": 0.041, "taxRate": 0.0053 },
  { "year": 2024, "region": "OH", "growthRate": 0.063, "taxRate": 0.0149 },
  { "year": 2024, "region": "SC", "growthRate": 0.065, "taxRate": 0.0056 },
  { "year": 2024, "region": "WA", "growthRate": 0.053, "taxRate": 0.0085 },
  { "year": 2025, "region": "AK", "growthRate": 0.02, "taxRate": 0.0104 },
  { "year": 2025, "region": "AL", "growthRate": 0.02, "taxRate": 0.0033 },
  { "year": 2025, "region": "AR", "growthRate": 0.02, "taxRate": 0.0052 },
  { "year": 2025, "region": "AZ", "growthRate": 0.04, "taxRate": 0.0072 },
  { "year": 2025, "region": "CA", "growthRate": 0.04, "taxRate": 0.0074 },
  { "year": 2025, "region": "CO", "growthRate": 0.04, "taxRate": 0.006 },
  { "year": 2025, "region": "CT", "growthRate": 0.02, "taxRate": 0.0163 },
  { "year": 2025, "region": "DC", "growthRate": 0.03, "taxRate": 0.0046 },
  { "year": 2025, "region": "DE", "growthRate": 0.03, "taxRate": 0.0043 },
  { "year": 2025, "region": "FL", "growthRate": 0.04, "taxRate": 0.0097 },
  { "year": 2025, "region": "GA", "growthRate": 0.04, "taxRate": 0.0083 },
  { "year": 2025, "region": "HI", "growthRate": 0.04, "taxRate": 0.0026 },
  { "year": 2025, "region": "IA", "growthRate": 0.025, "taxRate": 0.0129 },
  { "year": 2025, "region": "ID", "growthRate": 0.04, "taxRate": 0.0069 },
  { "year": 2025, "region": "IL", "growthRate": 0.02, "taxRate": 0.0173 },
  { "year": 2025, "region": "IN", "growthRate": 0.02, "taxRate": 0.0085 },
  { "year": 2025, "region": "KS", "growthRate": 0.025, "taxRate": 0.0129 },
  { "year": 2025, "region": "KY", "growthRate": 0.02, "taxRate": 0.0072 },
  { "year": 2025, "region": "LA", "growthRate": 0.02, "taxRate": 0.0018 },
  { "year": 2025, "region": "MA", "growthRate": 0.03, "taxRate": 0.0104 },
  { "year": 2025, "region": "MD", "growthRate": 0.025, "taxRate": 0.0087 },
  { "year": 2025, "region": "ME", "growthRate": 0.03, "taxRate": 0.0109 },
  { "year": 2025, "region": "MN", "growthRate": 0.025, "taxRate": 0.0105 },
  { "year": 2025, "region": "MO", "growthRate": 0.02, "taxRate": 0.0091 },
  { "year": 2025, "region": "MS", "growthRate": 0.02, "taxRate": 0.0052 },
  { "year": 2025, "region": "MT", "growthRate": 0.04, "taxRate": 0.0083 },
  { "year": 2025, "region": "NC", "growthRate": 0.03, "taxRate": 0.0078 },
  { "year": 2025, "region": "ND", "growthRate": 0.025, "taxRate": 0.0142 },
  { "year": 2025, "region": "NE", "growthRate": 0.025, "taxRate": 0.0176 },
  { "year": 2025, "region": "NH", "growthRate": 0.03, "taxRate": 0.0186 },
  { "year": 2025, "region": "NJ", "growthRate": 0.025, "taxRate": 0.0189 },
  { "year": 2025, "region": "NM", "growthRate": 0.025, "taxRate": 0.0055 },
  { "year": 2025, "region": "NV", "growthRate": 0.04, "taxRate": 0.0084 },
  { "year": 2025, "region": "NY", "growthRate": 0.02, "taxRate": 0.0123 },
  { "year": 2025, "region": "OH", "growthRate": 0.02, "taxRate": 0.0136 },
  { "year": 2025, "region": "OK", "growthRate": 0.02, "taxRate": 0.0074 },
  { "year": 2025, "region": "OR", "growthRate": 0.04, "taxRate": 0.0087 },
  { "year": 2025, "region": "PA", "growthRate": 0.02, "taxRate": 0.0135 },
  { "year": 2025, "region": "RI", "growthRate": 0.03, "taxRate": 0.0135 },
  { "year": 2025, "region": "SC", "growthRate": 0.03, "taxRate": 0.005 },
  { "year": 2025, "region": "SD", "growthRate": 0.025, "taxRate": 0.0128 },
  { "year": 2025, "region": "TN", "growthRate": 0.04, "taxRate": 0.0068 },
  { "year": 2025, "region": "TX", "growthRate": 0.03, "taxRate": 0.0181 },
  { "year": 2025, "region": "UT", "growthRate": 0.04, "taxRate": 0.006 },
  { "year": 2025, "region": "VA", "growthRate": 0.03, "taxRate": 0.0074 },
  { "year": 2025, "region": "VT", "growthRate": 0.03, "taxRate": 0.0159 },
  { "year": 2025, "region": "WA", "growthRate": 0.04, "taxRate": 0.0092 },
  { "year": 2025, "region": "WI", "growthRate": 0.025, "taxRate": 0.0176 },
  { "year": 2025, "region": "WV", "growthRate": 0.02, "taxRate": 0.0049 },
  { "year": 2025, "region": "WY", "growthRate": 0.03, "taxRate": 0.0058 }
]
